import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import queryString from 'query-string';
import { setExperiencesList, setExperienceSelected } from '../../../actions/experiences';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../../assets';

class PopularExperiences extends Component {
  constructor(props) {
    super(props);
  }

  renderExperienceTile = (experience) => {
    if (!experience || !experience.tile) {
      return null;
    }
    const linkTo = this.getExperienceGetStartedLinkTo(experience);
    return (
      <Col xs={6} sm={3} md={3} lg={3} key={experience.tile.title}>
        <Link to={linkTo}>
          <div className="popularExperienceLarge">
            <img className="image" src={experience.tile.imageSrc} alt={experience.tile.title} />
            <div className="name tertiaryHeadingFonts">{experience.tile.title}</div>
          </div>
          <div className="popularExperienceSmall">
            <div
              className="image"
              style={{ backgroundImage: 'url(' + experience.tile.imageSrc + ')' }}
              alt={experience.tile.title}
            />
            <div className="name tertiaryHeadingFonts">{experience.tile.title}</div>
          </div>
        </Link>
      </Col>
    );
  };

  // TODO: factor out this function with the same one in file TiledCards.js
  getExperienceGetStartedLinkTo = (experience) => {
    const queryData = queryString.parse(this.props.location.search);
    const getRoutePath = getPartnerAsset(DynamicAssetsKeys.expertSessionsPath);
    const linkTo = {
      pathname: getRoutePath,
      search: '?megaUseCase=' + experience.megaUseCase,
    };
    return linkTo;
  };

  getExperienceCategoryTitleColor = (experience) => {
    // TODO: check why numbers don't work here.
    let titleColor = 'black';
    switch (experience && experience.category.toUpperCase()) {
      case 'SECURITY':
        titleColor = 'orange';
        break;
      case 'DIGITAL LIFE':
        titleColor = 'purple';
        break;
      default:
        titleColor = 'black';
        break;
    }
    return titleColor;
  };

  pickRandomElementsFromArray = (sourceArray, randomCount) => {
    const randomArray = [];
    if (!sourceArray || !randomCount) {
      return randomArray;
    }
    if (randomCount >= sourceArray.length) {
      return sourceArray;
    }
    while (randomCount >= 1) {
      const randomIndex = Math.floor(Math.random() * sourceArray.length);
      randomArray.push(sourceArray[randomIndex]);
      sourceArray.splice(randomIndex, 1);
      --randomCount;
    }
    return randomArray;
  };

  render() {
    if (!this.props.experienceSelected || !this.props.experiencesList) {
      return null;
    }

    let popularExperiences = this.props.experiencesList.filter(
      (item) => item.megaUseCase !== this.props.experienceSelected.megaUseCase
    );
    popularExperiences = this.pickRandomElementsFromArray(popularExperiences, 4);

    return (
      <div className="PopularExperiencesContainer">
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="title articleTitleFonts">{this.props.popularExperiencsTitle}</div>
            </Col>
            {popularExperiences.map((item) => {
              return this.renderExperienceTile(item);
            })}
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  popularExperiencsTitle: state.experiences.experiencesList && state.experiences.experiencesList.popularExperiencsTitle,
  experienceSelected: state.experiences.experienceSelected,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperiencesList,
      setExperienceSelected,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PopularExperiences));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/PopularExperiences/PopularExperiences.js